import dayjs from "dayjs";
import { OrderGraphDTO } from "../../data/model/OrderGraphDTO";
import { Graph, GraphConfig, OrderGraphsModel } from "../model/GraphConfig";

export const OrderGraphModelMapper = {
  execute(dto: OrderGraphDTO): OrderGraphsModel {
    const keys = ["total_amount", "total_orders"];

    const config: GraphConfig = {};

    config["total_amount"] = {
      label: dto["total_amount"].name,
      value: dto["total_amount"].value,
      name: dto["total_amount"].name,
      toolTipTitle: dto["total_amount"].name,
      graph: dto["total_amount"].graph.map(
        (g) =>
          <Graph>{
            name: g.name,
            date: dayjs(Date.parse(g.date)).format("DD MM YYYY"),
            wolt: g.wolt,
            glovo: g.glovo,
            yandex: g.yandex,
            all: g.all,
          }
      ),
    };
    config["total_orders"] = {
      label: dto["total_orders"].name,
      value: dto["total_orders"].value,
      name: dto["total_orders"].name,
      toolTipTitle: dto["total_orders"].name,
      graph: dto["total_orders"].graph.map(
        (g) =>
          <Graph>{
            name: g.name,
            date: dayjs(Date.parse(g.date)).format("DD MM YYYY"),
            wolt: g.wolt,
            glovo: g.glovo,
            yandex: g.yandex,
            all: g.all,
          }
      ),
    };

    return { graphs: keys, config: config, downloadUrl: dto.file };
  },
};
